module.exports = __webpack_public_path__ + "static/img/cxzy.6760a19.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/cxzy.png
// module id = zXZh
// module chunks = 1